module.exports = __webpack_public_path__ + "static/media/trend-logo-black.96522325.svg";